export default function time() {
    let timeOfDay;
    const date = new Date();
    const hours = date.getHours();
  
    if (hours < 12) {
      timeOfDay = 'Good Morning! ';
    } else if (hours >= 12 && hours < 17) {
      timeOfDay = 'Good Afternoon! ';
    } else {
      timeOfDay = 'Good Evening! '
    }
  
    return (
      <h1 className="time">{timeOfDay} </h1>
    )
  };